import React from 'react';

import AppContext from './appContext';

export default function useAppContext() {
    const ctx = React.useContext(AppContext);
    if (!ctx) {
        throw new Error('[useAppContext] Did you call useAppContext outside an AppContextProvider component?');
    }

    const { context, setContext, removeFromContext } = ctx;

    return [context, setContext, removeFromContext];
}
